

export const LIST_PERMISSION_ONE_USER_SUCCESS = "LIST_PERMISSION_ONE_USER__SUCCESS";
export const LIST_PERMISSION_ONE_USER__FAIL = "LIST_PERMISSION_ONE_USER__FAIL";